<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
    <product-category-list-filter
      @edit="editComponentFilters($event, 'filter__categories__in')"
      @clean="cleanComponentFilters(['filter__categories__in'])"
    />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as PRODUCT_TYPES } from './store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'ProductCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: PRODUCT_TYPES.GENERIC.product.product.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...PRODUCT_TYPES.GENERIC.product.product.LIST.ACTIONS
    })
  }
}
</script>
